<template>
  <b-modal :id="id" :cancel-title="$t('_cancel')" ref="allow" @ok="confirm">
    {{ question }}
  </b-modal>
</template>

<script>
import modalMixin from '@/components/frontoffice/Booking/modal/mixin'
import { status } from '@/utils/bookingStatus'

export default {
  name: 'booking-modal-allow',

  mixins: [modalMixin],

  props: {
    id: {
      type: String,
      default: "allow"
    },
    bookingStatus: Number,
    isOnline: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      submitterInfos: {
        type: 'booking_allow',
        values: {
          isUnlogged: this.isUnlogged
        }
      },
      key: 'allow'
    }
  },

  created () {
    if (this.bookingStatus && this.bookingStatus === status.WAITING_FOR_MANAGER_POST_VALIDATION)
      this.key = this.isOnline
        ? 'allow_booking'
        : 'validate'
  },

  computed: {
    question () {
      return this.$t(`booking.${this.key}.question`)
    },

    successMessage () {
      return this.$t(`booking.${this.key}.validation`)
    }
  }
}
</script>
